<template>
  <FlotoDownloadLink :file-name="`${resource.name}.pdf`" :url="printUrl">
    <template v-slot="{ downloading }">
      <MIcon v-if="!downloading" name="print" class="action-menu-icon" />
      <span class="ml-1 action-menu-text">
        {{ $t('print') }}
      </span>
    </template>
  </FlotoDownloadLink>
</template>

<script>
import { authComputed } from '@state/modules/auth'
export default {
  name: 'Print',
  props: {
    moduleName: { type: String, required: true },
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
  },
  computed: {
    ...authComputed,
    printUrl() {
      if (this.accessToken) {
        return `/analytics/download/print/${this.moduleName}/${[
          this.resourceId,
        ]}`
      }
      return undefined
    },
  },
}
</script>
